import { Component, OnInit } from '@angular/core';
import { GruposService } from 'src/app/services/grupos.service';
import { Subject } from 'rxjs';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';


@Component({
  selector: 'app-sesion-tematica',
  templateUrl: './sesion-tematica.component.html',
  styleUrls: ['./sesion-tematica.component.scss']
})
export class SesionTematicaComponent implements OnInit {
  respuestaSesionesTematicas:any;
  sesiones;
  respuestaAgregarSesion:any;
  respuestaEditarSesion:any;
  respuestaUpdateSesion:any;

  datosSesion;
  sesionid;
  data;

  formulario;
  formularioEdit;

  dtOptions: DataTables.Settings = {
    dom: 'tip',                      // Estructura de la tabla     --> https://datatables.net/reference/option/dom
    lengthMenu: [],                      // Menú de tamaños de página   --> https://datatables.net/reference/option/lengthMenu
    order: [1, 'desc'],
    paging: true,
    pagingType: 'simple_numbers',
    pageLength: 10,
  };
  dtTrigger: Subject<any> = new Subject();

  constructor(private _getSesionesTematicas:GruposService, private _agregarSesionTematica: CatalogosService, 
    private _editarSesionTematica: CatalogosService, private _updateSesionTematica: CatalogosService,
    private modalService: NgbModal, private iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getSesionesTematicas();
    this.formulario = {
      'nombre':'',
    }

    this.formularioEdit = {
      'nombre':'',
    }
  }

  getSesionesTematicas(){
    this._getSesionesTematicas.getSesionesTematicas().subscribe(
      data => {
        this.respuestaSesionesTematicas = data;
        if(this.respuestaSesionesTematicas.success){
          this.sesiones = this.respuestaSesionesTematicas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarSesionTematica(){
    this.data = {
      'nombre': this.formulario.nombre,
    }

    this._agregarSesionTematica.agregarSesionTematica(this.data).subscribe(
      data => {
        this.respuestaAgregarSesion = data;
        if(this.respuestaAgregarSesion.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getSesionesTematicas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editarSesionTematica(sesion){
    this.data = {
      'sesion':sesion,
    }
    this._editarSesionTematica.editarSesionTematica(this.data).subscribe(
      data => {
        this.respuestaEditarSesion= data;
        if(this.respuestaEditarSesion.success){
          this.datosSesion = this.respuestaEditarSesion.content;
          this.formularioEdit.nombre = this.datosSesion.nombre;
          this.sesionid = sesion;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateSesionTematica(sesion){
    this.data = {
      'sesion': sesion, 
      'nombre': this.formularioEdit.nombre,
    }

    this._updateSesionTematica.updateSesionTematica(this.data).subscribe(
      data => {
        this.respuestaUpdateSesion = data;
        if(this.respuestaUpdateSesion.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getSesionesTematicas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }


  

}
